module.exports = __webpack_public_path__ + "img/ROBOTICS_MV.63844448.png";